
// src/hooks/useCustomA4Print.js
import * as React from "react";
import { useReactToPrint } from "react-to-print";


const getPageMargins = () => {
  return `
  @media print {
    width : 205mm;
    margin-left: 100px;
  }
  `;
};


function useCustomA4Print(title, onAfterPrint) {
  const componentRef = React.useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: title,
    pageStyle: getPageMargins,
    onAfterPrint,
  });

  return { componentRef, handlePrint };
}

export { useCustomA4Print };
